export const SET_POST_SUSPENDED = 'frame.setPostSuspended';
export const POST_MESSAGE = 'frame.postMessage';
export const CLEAR_MESSAGES = 'frame.clearMessages';

/**
 * Nastaví pozastavení zpracování zpráv ve frontě.
 * @param area oblast
 * @param suspended zda je zpracování pozastaveno
 */
export function setPostSuspended(area, suspended) {
    return {
        type: SET_POST_SUSPENDED,
        area,
        suspended,
    };
}

/**
 * Poslání zprávy do frame.
 * @param area oblast
 * @param message message pro poslání
 */
export function postMessage(area, message) {
    return {
        type: POST_MESSAGE,
        area,
        message,
    }
}

/**
 * Smazání všech zpráv ve store, volá se např. po jejich odeslání komponentou.
 * @param area oblast
 */
export function clearMessages(area) {
    return {
        type: CLEAR_MESSAGES,
        area,
    }
}
